import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import ReceptionForm from "./reception/reception-form";
import LoadReviewForm from "./load-review/load-review-form";
import CubiscanForm from "./cubiscan/cubiscan-form";
import LocationsForm from "./locations/locations-form";

function FormsView({ master, loading, setLoading }) {
  const [activeForm, setActiveForm] = useState("reception");
  const [selectedSubproduct, setSelectedSubproduct] = useState(null);
  const [receptionFormData, setReceptionFormData] = useState(null);
  const [isLoadingReceptionData, setIsLoadingReceptionData] = useState(false);

  const isConsolidated = Array.isArray(master?.data) && master.data.length > 0;

  const loadReceptionData = async (houseId = null) => {
    try {
      setIsLoadingReceptionData(true);
      const masterId = master.resp?.id || master.resp?.master_id;

      let url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/reception_form?master_id=${masterId}`;

      if (houseId) {
        url += `&house_id=${houseId}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.code === 1) {
        setReceptionFormData(response.data.data);
        return response.data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error al cargar formulario:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudieron cargar los datos del formulario de recepción",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return null;
    } finally {
      setIsLoadingReceptionData(false);
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      // Solo cargar si no hay datos de recepción aún
      if (!receptionFormData) {
        await loadReceptionData();

        // Si no hay subproductos consolidados, activar recepción automáticamente
        if (!isConsolidated) {
          setActiveForm("reception");
        }
      }
    };

    loadInitialData();
  }, []);

  const handleFormClick = async (form) => {
    setSelectedSubproduct(null);
    if (form === "reception") {
      // Si no hay datos de recepción cargados, cargarlos
      if (!receptionFormData && !isLoadingReceptionData) {
        await loadReceptionData();
      }
      setActiveForm(form);
    } else {
      setActiveForm(form);
    }
    setSelectedSubproduct(null);
  };

  const showForm = async (sub, targetForm = "reception") => {
    if (targetForm === "reception") {
      const data = await loadReceptionData(sub?.id);
      if (data) {
        setSelectedSubproduct(sub);
        setActiveForm("reception");
      }
      return;
    }

    setSelectedSubproduct(sub);
    setActiveForm(targetForm);
  };

  const renderForm = () => {
    switch (activeForm) {
      case "reception":
        if (isLoadingReceptionData) {
          return (
            <div className="text-center p-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <p className="mt-3">
                Cargando datos del formulario de recepción...
              </p>
            </div>
          );
        }

        if (!receptionFormData) {
          return (
            <div className="alert alert-warning text-center">
              <p>
                No se pudieron cargar los datos del formulario de recepción.
              </p>
              <button
                className="btn btn-primary btn-sm mt-2"
                onClick={() => loadReceptionData()}
              >
                Reintentar
              </button>
            </div>
          );
        }

        return (
          <ReceptionForm
            master={receptionFormData}
            parentMaster={master}
            subproduct={selectedSubproduct}
            isConsolidated={isConsolidated}
            showForm={showForm}
          />
        );

      case "review":
        return <LoadReviewForm master={master} />;

      case "cubiscan":
        return (
          <CubiscanForm
            master={master}
            subproduct={selectedSubproduct}
            isConsolidated={isConsolidated}
            showForm={showForm}
          />
        );

      case "locations":
        return (
          <LocationsForm
            master={master}
            subproduct={selectedSubproduct}
            loading={loading}
            setLoading={setLoading}
          />
        );

      default:
        return;
    }
  };

  return (
    <div className="container-fluid">
      {/* Botones de navegación */}
      <div className="d-flex gap-3 mb-4 flex-wrap">
        <button
          onClick={() => handleFormClick("reception")}
          className={`btnn ${activeForm === "reception" ? "active" : ""}`}
          disabled={isLoadingReceptionData}
        >
          {isLoadingReceptionData ? "Cargando..." : "Recepción de documentos"}
        </button>
        <button
          onClick={() => handleFormClick("review")}
          className={`btnn ${activeForm === "review" ? "active" : ""}`}
        >
          Revisión de la carga
        </button>
        <button
          onClick={() => handleFormClick("cubiscan")}
          className={`btnn ${activeForm === "cubiscan" ? "active" : ""}`}
        >
          Cubiscan
        </button>
        <button
          onClick={() => handleFormClick("locations")}
          className={`btnn ${activeForm === "locations" ? "active" : ""}`}
        >
          Locaciones
        </button>
      </div>

      <div className="content-area">
        {activeForm === "locations" ? (
          <LocationsForm
            master={master}
            subproduct={selectedSubproduct}
            loading={loading}
            setLoading={setLoading}
          />
        ) : (
          <>{renderForm()}</>
        )}
      </div>

      {isLoadingReceptionData && (
        <div className="alert alert-info text-center mt-3">
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          Cargando datos del formulario...
        </div>
      )}

      {!master && (
        <div className="alert alert-warning text-center">
          No se encontraron datos del master. Por favor, regrese y busque
          nuevamente.
        </div>
      )}
    </div>
  );
}

export default FormsView;
